export const PERSONAL_CAPACITY_NOTICE_ID = "personal-capacity-notice";

const PersonalCapacityNotice = () => (
    <p className="text-clhbid-white text-xs/5" id={PERSONAL_CAPACITY_NOTICE_ID}>
        <strong>
            All bidders must register and bid in their own personal name.
        </strong>{" "}
        A successful bidder may, following the sale, assign the OTP to a
        corporation, provided that any such assignment shall be with recourse to
        the successful bidder, who shall remain fully liable for the performance
        of all obligations under the OTP notwithstanding the assignment.
    </p>
);

export default PersonalCapacityNotice;
